import { render, staticRenderFns } from "./PayOrder.vue?vue&type=template&id=870b0852&scoped=true&"
import script from "./PayOrder.vue?vue&type=script&lang=js&"
export * from "./PayOrder.vue?vue&type=script&lang=js&"
import style0 from "./PayOrder.vue?vue&type=style&index=0&id=870b0852&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870b0852",
  null
  
)

component.options.__file = "src/components/order/PayOrder.vue"
export default component.exports